/*
 * Created by alex@hackerbay.com on 25.1.2019
 * Copyright Singularity Technologies GmbH (c) 2019. All rights reserved
 */

import * as React from "react";
import {translate, Trans} from "react-i18next";
import i18n from "i18next";
import {Header} from "../../components/Header";
import TextBody from "../../components/TextBody";
import BottomBar from "../../components/BottomBar";
import TopNav from "../../components/TopNav";
import {Col, Container, Row} from "reactstrap";
import StatusOverview from "../../components/StatusBar";
import Subtitle from "../../components/Subtitle";
import SavePageButton from "../../components/SavePageButton";
import StackedBottomButtonPair from "../../components/StackedBottomButtonPair";
import StatusBox from "../../components/StatusBox";
import StatusBar from "../../components/StatusBar";
import BottomBarActive from "../../components/BottomBarActive";
import {SpacerRow} from "../../components/SpacerRow";
import {BrowserView,MobileView,isMobile} from "react-device-detect";
import BottomBarMeinVodafone from "../../components/BottomBarMeinVodafone";
import SingleButton from "../../components/SingleButton";
import SideBarMeinVodafone from "../../components/SideBarMeinVodafone";
import {StatusBarDesktop} from "../../components/StatusBarDesktop";
import ActionButton, {ACTION_BUTTON_COLORS} from "../../components/ActionButton";
import {openNetzAssistent,openVodafoneHilfe} from "../../netzAssistent";
import technicianAppointmentRequired from "../../technicianRequired";
import {hardwareWasShipped} from "../../hardwareHelper";
import vodafoneLogo from "../../media/icons/vf-logo.png";



class Stage11InternetProblems extends React.Component {
    constructor(props){
        super(props);
    }

    showMeinVodafoneLogin = () => {
        window.open("https://www.vodafone.de/meinvodafone");
    };

    render() {

		/**
		 * Top Navigation / "Footer" Link
		 */
		const footerLnk = <TopNav
			buttonTextResource={"footer_link"}
			buttonOnClick={this.props.openTopNav}
		/>;

        return <Container>

            <MobileView>
                <Row>
                    <Col xs={2} style={{marginTop:"15px"}}>
                        <img src={vodafoneLogo} className={"img-fluid"}  alt={"Vodafone Logo"}/>
                    </Col>
                    {footerLnk}
                </Row>
                <StatusBar
                    currentStage={this.props.currentStage}
                    technicianAppointmentRequired={technicianAppointmentRequired(this.props.ds360APIResult)}
                    customerWillGetAPackage={hardwareWasShipped(this.props.orderStatus)}
                />
                <SpacerRow/>
                <Header
                    textResource={"internet_problems_title"}
                />

                <span className={"fixed-to-bottom"}>

                <Row>
                    <Col xs={7}>
                        <Subtitle
                            textResource={"vodafone_hilfe_title_desktop"}
                        />
                    </Col>
                    <ActionButton
                        color={ACTION_BUTTON_COLORS.GREY}
                        textResource={"launch_vodafone_hilfe"}
                        onClick={openVodafoneHilfe}
                    />
                </Row>
                <BottomBarMeinVodafone
                    mainText={"myvodafone"}
                    subText={"myvodafone_description"}
                    buttonTextResource={"login"}
                    buttonOnClick={this.showMeinVodafoneLogin}
                />
            </span>
            </MobileView>

            <BrowserView>
                    <Row>
                    {footerLnk}
                    </Row>
                <StatusBarDesktop
                    currentStage={this.props.currentStage}
                    technicianAppointmentRequired={technicianAppointmentRequired(this.props.ds360APIResult)}
                    customerWillGetAPackage={hardwareWasShipped(this.props.orderStatus)}
                />
                <Row>
                    <Col xs={7}  lg={{ size: 5, offset: 1 }} style={{marginTop:"12px"}}>
                        <Header
                            textResource={"internet_problems_title"}
                        />
                        <SpacerRow/>
                        <SpacerRow/>
                        <SpacerRow/>
                        <Row>
                            <Col xs={9}>
                                <Subtitle
                                    textResource={"vodafone_hilfe_title_desktop"}
                                />
                            </Col>
                            <Col xs={9} style={{paddingLeft:0}}>
                                <ActionButton
                                    color={ACTION_BUTTON_COLORS.GREY}
                                    textResource={"launch_vodafone_hilfe"}
                                    onClick={openVodafoneHilfe}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={5}  lg={{ size: 4, offset: 1 }} className={"round-corners shadow bg-red-gradient"}>
                        <SideBarMeinVodafone
                            mainText={"myvodafone"}
                            subText={"myvodafone_description"}
                        />
                        <SpacerRow/>
                        <SpacerRow/>
                        <SpacerRow/>
                        <SingleButton
                            buttonTextResource={"login"}
                            buttonOnClick={this.showMeinVodafoneLogin}
                            buttonStyleIsWhite={true}
                        />
                        <SpacerRow/>
                    </Col>
                </Row>
            </BrowserView>
        </Container>
    }
}

export default translate("translations")(Stage11InternetProblems);
